import ModalShareCartPresenter from "./modal-share-cart.js";

import TriggerView from "../view/trigger.js";

import ModalShareCartTriggerModel from "../model/modal-share-cart.js";

import {
  sendXhr
} from "../../../../utils/send-xhr/send-xhr.js";

import ChangeUrl from "../../../change-url/presenter/change-url.js";

import {
  ActionType,
  defaultModalShareCartTriggerModelData,
  RequestAction,
  CONNECTOR_URL,
  CART_ID_KEY
} from "../../const.js";

export default class ModalShareCartTrigger {
  constructor(triggerElement) {
    this._triggerElement = triggerElement;

    this._changeUrl = new ChangeUrl();

    this._modalShareCartPresenter = null;

    this._triggerView = new TriggerView(this._triggerElement);
    this._model = new ModalShareCartTriggerModel(Object.assign(
        {},
        defaultModalShareCartTriggerModelData
    ));

    this._handleTriggerClick = this._handleTriggerClick.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
    this._domContentLoadedHandler = this._domContentLoadedHandler.bind(this);
  }

  init() {
    this._triggerView.setClickHandler(this._handleTriggerClick);
    this._model.addObserver(this._handleChangeData);

    document.addEventListener(`DOMContentLoaded`, this._domContentLoadedHandler);
  }

  reset() {
    if (!this._modalShareCartPresenter) {
      return;
    }

    this._modalShareCartPresenter.reset();
  }

  _processShowModal(data) {
    this._modalShareCartPresenter = new ModalShareCartPresenter(data);
    this._modalShareCartPresenter.build();
  }

  _processClicking() {
    const body = [
      `action=${RequestAction.SAVE_CART}`
    ];

    const args = {
      body,
      connectorUrl: CONNECTOR_URL,
      loadCallback: (response) => {
        const data = JSON.parse(response);

        if (!data.success) {
          console.error(data.error);
          return;
        }

        this._model.changeData(Object.assign(
            {},
            this._model.getData(),
            {
              isClicking: false,
              isModalShown: true
            }
        ), ActionType.SHOW_MODAL, {
          cartId: data.cart_id
        });

        return;
      }
    };

    sendXhr(args);
  }

  _handleTriggerClick() {
    if (this._model.getData().isClicking) {
      return;
    }

    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          isClicking: true
        }
    ), ActionType.CLICKING);
  }

  _handleChangeData(action, payload) {
    switch (action) {
      case ActionType.CLICKING:
        this._processClicking();
        break;
      case ActionType.SHOW_MODAL:
        this._processShowModal(payload);
        break;
    }
  }

  _domContentLoadedHandler() {
    const searchCartProperty = document.location.search
      .replace(/^\?/, ``)
      .split(`&`)
      .find((item) => {
        const data = item.split(`=`);

        return data[0] === `${CART_ID_KEY}`;
      });

    if (!searchCartProperty) {
      return;
    }

    let searchParams = document.location.search
      .replace(/^\?/, ``)
      .split(`&`)
      .filter((item) => {
        const data = item.split(`=`);

        return data[0] !== `${CART_ID_KEY}`;
      });

    const url = (searchParams.length > 0) ?
      `${document.location.origin}${document.location.pathname}?${searchParams.join(`&`)}` :
      `${document.location.origin}${document.location.pathname}`;

    this._changeUrl.change(searchParams, url, true);
  }
}
